const routes = {
  login: 'auth/login',
  register: 'auth/register',
  forgetPassword: 'users/forgetPassword',
  resetPassword: 'users/resetPassword',
  getSideNavigation: 'users/permissions',
  changePassword: 'users/changePassword',
  handleLogout:'auth/logout',
  Linking:'auth/link'
};

export default routes